<template>
    <div class="modal-custom-container">
        <div class="main-modal">
            <div class="section dir-rtl" style="padding-top: 0">
                <span
                    class="error"
                    ref="error"
                    style="margin-top: 5px; display: block"
                    >{{ $t("error") }}</span
                >
                <br />
                <div v-if="errosList">
                    <span
                        v-for="(error, index) in errosList"
                        :key="index"
                        class="error"
                        style="visibility: unset; display: block"
                        >{{ error.toString() }}</span
                    >
                </div>
                <b-tooltip
                    :label="$t('Please use only English letters')"
                    :active="notify"
                    always
                ></b-tooltip>
                <div class="pages">
                    <div class="columns" style="display: flex; flex-wrap: wrap">
                        <!-- <div
                            :class="[
                                'column',
                                { 'is-12': model.address.country },
                            ]"
                        >
                            <label>{{ $t("Country") }}</label>
                            <basic-select
                                :options="options"
                                :placeholder="$t('Country')"
                                @raw="handleCountrySelect($event)"
                                :counterError="false"
                                ref="country"
                                :directSearchAccessValue="
                                    model.address.countryName
                                "
                                @notify="notify = $event"
                                :showFlag="true"
                                :showErrorRequired="
                                    firstPageErrors.includes('country')
                                "
                            ></basic-select>
                        </div> -->

                        <template>
                            <div
                                style="padding: 18px 12px"
                                class="column is-12"
                            >
                                <div
                                    :class="[
                                        'custom-input',
                                        model.address1.length > 2
                                            ? 'active'
                                            : '',
                                    ]"
                                >
                                    <label>{{ $t("Street title") }}</label>
                                    <input
                                        :placeholder="$t('Street title')"
                                        name="address"
                                        v-model="model.address1"
                                        @input="filterErrors('address1', false)"
                                        :required="true"
                                        :maxlength="44"
                                    />
                                    <img
                                        v-if="model.address1.length > 2"
                                        src="@/assets/images/CHECK-Mark.svg"
                                        style="width: 15px"
                                    />
                                </div>
                                <span
                                    class="error show"
                                    v-if="firstPageErrors.includes('address1')"
                                    >{{ $t("Please add a valid info") }}</span
                                >
                            </div>

                            <div
                                style="padding: 18px 12px"
                                class="column is-12"
                                v-if="model.address.country != 187"
                            >
                                <div
                                    :class="[
                                        'custom-input',
                                        model.address2.length > 2
                                            ? 'active'
                                            : '',
                                    ]"
                                >
                                    <label>{{
                                        checkArabCountry()
                                            ? $t("District details")
                                            : $t("Building, Apartment, Suite") +
                                              " " +
                                              $t("( optional )")
                                    }}</label>
                                    <input
                                        :placeholder="
                                            checkArabCountry()
                                                ? $t('District details')
                                                : $t(
                                                      'Building, Apartment, Suite'
                                                  )
                                        "
                                        name="address_2"
                                        v-model="model.address2"
                                        :maxlength="44"
                                    />
                                    <img
                                        v-if="model.address2.length > 2"
                                        src="@/assets/images/CHECK-Mark.svg"
                                        style="width: 15px"
                                    />
                                </div>
                            </div>

                            <div
                                style="padding: 18px 12px"
                                :class="`column basic-select is-6`"
                            >
                                <Loading v-show="loading" />
                                <label>{{ $t("City name") }}</label>
                                <search-box
                                    v-show="!loading"
                                    :placeholder="$t('City name')"
                                    :data="citiesOptions"
                                    @input="setCitySelected($event)"
                                    @notify="notify = $event"
                                    name="city"
                                    :capitalize="false"
                                    :isGetByID="true"
                                    :required="true"
                                    :directSearchAccessValue="
                                        model.address.city
                                    "
                                ></search-box>
                                <span
                                    class="error show"
                                    v-if="firstPageErrors.includes('city')"
                                    >{{
                                        $t(
                                            "Please add a valid info, And choose city from suggestions"
                                        )
                                    }}</span
                                >
                            </div>
                            <div
                                style="padding: 18px 12px"
                                class="column is-6"
                                v-if="model.address.country == 187"
                            >
                                <div
                                    :class="[
                                        'custom-input',
                                        model.address.district.length > 2
                                            ? 'active'
                                            : '',
                                    ]"
                                >
                                    <label
                                        >{{ $t("District name") }}
                                        {{ $t("( optional )") }}</label
                                    >
                                    <input
                                        :placeholder="$t('District name')"
                                        name="districtName"
                                        v-model="model.address.district"
                                        :maxlength="44"
                                    />
                                    <img
                                        v-if="model.address.district.length > 2"
                                        src="@/assets/images/CHECK-Mark.svg"
                                        style="width: 15px"
                                    />
                                </div>
                            </div>
                            <div
                                class="column is-6"
                                style="padding: 18px 12px"
                                v-if="model.address.country == 187"
                            >
                                <div class="custom-input">
                                    <label
                                        >{{ $t("Building number") }}
                                        {{ $t("( optional )") }}</label
                                    >
                                    <input
                                        :placeholder="$t('Building number')"
                                        name="bldg"
                                        v-model="model.address.bldg"
                                        onkeypress="if(this.value.length==this.maxLength) return false;"
                                        :maxlength="10"
                                    />
                                    <img
                                        v-if="model.address.bldg.length > 2"
                                        src="@/assets/images/CHECK-Mark.svg"
                                        style="width: 15px"
                                    />
                                </div>
                            </div>
                            <!-- <div
                                style="padding: 18px 12px"
                                :class="[
                                    'column',
                                    model.address.country == 187
                                        ? 'is-6'
                                        : 'is-6',
                                ]"
                            >
                                <Loading v-show="loading" />
                                <label>{{
                                    model.address.country === 226
                                        ? $t("Zip Code")
                                        : $t("Postal Code") +
                                          " " +
                                          $t("( optional )")
                                }}</label>
                                <search-box
                                    v-show="!loading"
                                    :placeholder="
                                        model.address.country === 226
                                            ? $t('Zip Code')
                                            : $t('Postal Code')
                                    "
                                    :data="postCodeSearchResultByKeyword"
                                    @input="postalCodeHandlers($event)"
                                    name="zip"
                                    :required="true"
                                    :isZipCode="true"
                                    :minlength="4"
                                    :directSearchAccessValue="model.address.zip"
                                    :maxlength="5"
                                ></search-box>
                                <span
                                    class="error show"
                                    v-if="firstPageErrors.includes('zip')"
                                    >{{ $t("Please Enter valid Code") }}</span
                                >
                            </div> -->
                        </template>
                    </div>
                </div>

                <div class="pages" v-if="model.address.country">
                    <div class="columns">
                        <div class="column">
                            <div
                                :class="[
                                    'custom-input',
                                    model.full_name.length > 2 ? 'active' : '',
                                ]"
                            >
                                <label>{{ $t("Full Name") }}</label>
                                <input
                                    :placeholder="$t('Full Name')"
                                    name="full_name"
                                    v-model="model.full_name"
                                    @input="filterErrors('full_name', false)"
                                    :required="true"
                                />
                                <img
                                    v-if="model.full_name.length > 2"
                                    src="@/assets/images/CHECK-Mark.svg"
                                    style="width: 15px"
                                />
                            </div>
                            <span
                                class="error show"
                                v-if="secondPageErrors.includes('full_name')"
                                >{{ $t("Please add a valid info") }}</span
                            >
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div
                                :class="[
                                    'custom-input',
                                    model.company_name.length > 2
                                        ? 'active'
                                        : '',
                                ]"
                            >
                                <label>{{
                                    $t(
                                        "Company name (If you don't have, write your Full name)"
                                    )
                                }}</label>
                                <input
                                    :placeholder="
                                        $t(
                                            'Company name (If you don\'t have, write your Full name)'
                                        )
                                    "
                                    name="company_name"
                                    v-model="model.company_name"
                                    @input="filterErrors('company_name', false)"
                                    :required="true"
                                    autocomplete="new-password"
                                    maxlength="40"
                                    style="text-transform: capitalize"
                                />
                                <img
                                    v-if="model.company_name.length > 2"
                                    src="@/assets/images/CHECK-Mark.svg"
                                    style="width: 15px"
                                />
                            </div>
                            <span
                                class="error show"
                                v-if="secondPageErrors.includes('company_name')"
                                >{{ $t("Please add a valid info") }}</span
                            >
                        </div>
                    </div>
                    <div
                        class="columns"
                        style="display: flex; align-items: center"
                    >
                        <!-- <div class="column">
                            <div
                                :class="[
                                    'custom-input',
                                    model.email.length > 6 ? 'active' : '',
                                ]"
                            >
                                <label>{{ $t("Email") }}</label>
                                <input
                                    type="email"
                                    :placeholder="$t('Email')"
                                    name="email"
                                    v-model="model.email"
                                    @keydown.space.prevent
                                    :required="true"
                                    style="text-transform: baseline"
                                />
                                <img
                                    v-if="model.email.length > 6"
                                    src="@/assets/images/CHECK-Mark.svg"
                                    style="width: 15px"
                                />
                            </div>
                            <span
                                class="error show"
                                v-if="secondPageErrors.includes('email')"
                                >{{ $t("Please add a valid info") }}</span
                            >
                        </div> -->
                        <div class="column" style="width: calc(100% - 115px)">
                            <div
                                :class="[
                                    'custom-input',
                                    model.phone_number.number.length >
                                    (model.address.country == 187 ? 8 : 11)
                                        ? 'active'
                                        : '',
                                ]"
                            >
                                <label>{{ $t("Phone Number") }}</label>
                                <input
                                    type="number"
                                    :placeholder="$t('Phone Number')"
                                    name="phone_number"
                                    v-model="model.phone_number.number"
                                    onkeypress="if(this.value.length==this.maxLength) return false;"
                                    :required="true"
                                    :maxlength="
                                        model.address.country == 187 ? 9 : 12
                                    "
                                />
                                <img
                                    v-if="
                                        model.phone_number.number.length >
                                        (model.address.country == 187 ? 8 : 11)
                                    "
                                    src="@/assets/images/CHECK-Mark.svg"
                                    style="width: 15px"
                                />
                            </div>
                            <span
                                class="error show"
                                v-if="secondPageErrors.includes('phone_number')"
                                >{{
                                    $t(
                                        "Please add a valid info, numbers are in English and without spaces"
                                    )
                                }}</span
                            >
                        </div>
                        <div
                            :class="[
                                'column is-2 phone-code-helper',
                                { 'm-12': secondPageErrors.length },
                            ]"
                            style="width: 40px; margin-top: 38px"
                        >
                            <span>{{ model.phone_number.area_code }}+</span>
                            <i
                                :class="`flag-icon flag flag-icon-${
                                    phoneCode ? phoneCode.toLowerCase() : null
                                }`"
                                style="margin: 0 5px"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>
            <button
                :class="[`button`, { 'is-loading': loading }]"
                :disabled="loading"
                @click="$emit('cancel')"
                v-if="!activePage"
            >
                {{ $t("Cancel") }}
            </button>
            <button
                :class="[`button is-primary`, { 'is-loading': loading }]"
                :disabled="loading"
                @click="checkDataStep2"
                v-if="!activePage"
            >
                {{ isEditModal ? $t("Edit") : $t("Add") }}
            </button>
        </div>
    </div>
</template>

<script>
import { http, API } from "@/store/API";
// import BasicSelect from "@/components/BasicSelect.vue";
import Loading from "@/components/Loading";
import searchBox from "@/components/searchBox.vue";

export default {
    props: ["addressData", "person"],
    components: {
        // "basic-select": BasicSelect,
        searchBox,
        Loading,
    },
    data() {
        return {
            isEditModal: false,
            notify: false,
            model: {
                full_name: "",
                company_name: "",
                phone_number: {
                    area_code: "",
                    number: "",
                },
                phone: "",
                email: "",
                address1: "",
                address2: "",
                address: {
                    country: 0,
                    state: "",
                    city: "",
                    city_id: "",
                    zip: "",
                    district: "",
                    bldg: "",
                    countryName: "",
                },
                value: 0,
            },
            phoneCode: null,
            errosList: [],
            loading: false,
            currentValidCity: true,
            currentValidZip: true,
            loadingZip: false,
            activePage: false,
            zipOptions: [],
            firstPageErrors: [],
            secondPageErrors: [],
            ignored: [],
        };
    },
    methods: {
        checkLang(key, inside) {
            let englishRegex = /[^A-Za-z0-9\s]/gi;
            if (inside) {
                if (englishRegex.test(this.model[inside][key])) {
                    this.model[inside][key] = "";
                    this.notify = true;
                    return;
                }
            } else {
                if (englishRegex.test(this.model[key])) {
                    this.model[key] = "";
                    this.notify = true;
                    return;
                }
            }
            this.notify = false;
        },
        filterErrors(key, inside) {
            this.firstPageErrors = this.firstPageErrors.filter((k) =>
                k.include()
            );
            // this.checkLang(key, inside);
        },
        checkDataStep2() {
            let firstCheck = this.checkData();
            this.secondPageErrors = [];
            if (this.model.full_name.length < 2) {
                this.secondPageErrors.push("full_name");
            } else {
                this.secondPageErrors.filter((err) => err != "full_name");
            }
            if (this.model.company_name.length < 2) {
                this.secondPageErrors.push("company_name");
            } else {
                this.secondPageErrors.filter((err) => err != "company_name");
            }
            if (this.model.phone_number.number.length < 7) {
                this.secondPageErrors.push("phone_number");
            } else {
                this.secondPageErrors.filter((err) => err != "phone_number");
            }
            // if (this.model.email.length < 6) {
            //     this.secondPageErrors.push("email");
            // } else {
            //     this.secondPageErrors.filter((err) => err != "email");
            // }
            if (!firstCheck) return;
            if (this.secondPageErrors.length) return;
            this.isEditModal ? this.edit() : this.create();
        },
        checkData() {
            if (this.model.address.country == 187) {
                this.ignored = [
                    "state",
                    "countryName",
                    "zip",
                    "bldg",
                    "district",
                    "city_id",
                ];
            } else if (this.model.address.country == 226) {
                this.ignored = ["countryName", "district", "bldg"];
            } else {
                this.ignored = [
                    "countryName",
                    "district",
                    "bldg",
                    "state",
                    "city_id",
                ];
            }
            this.firstPageErrors = [];
            Object.keys(this.model.address).map((key) => {
                if (
                    (this.model.address[key] == 0 ||
                        this.model.address[key] == "" ||
                        (this.model.address[key] &&
                            this.model.address[key].length < 3)) &&
                    !this.ignored.includes(key)
                ) {
                    this.firstPageErrors.push(key);
                }
            });
            if (this.model.address1 == "") {
                this.firstPageErrors.push("address1");
            }
            if (
                this.model.address2 == "" &&
                this.model.address.country != 187 &&
                this.model.address.country != 226
            ) {
                this.firstPageErrors.push("address2");
            }

            if (!this.firstPageErrors.length) {
                if (this.model.address.country == 187) {
                    this.model.address2 = `${this.model.address.district} dist - BLDG# ${this.model.address.bldg}`;
                }
                return true;
            }
            return false;
        },
        create() {
            this.$refs.error.classList.remove("show");
            this.loading = true;
            this.$store
                .dispatch("createAddress", {
                    full_name: this.model.full_name,
                    email: this.model.email,
                    country_id: this.model.address.country,
                    city: this.model.address.city,
                    city_id: this.model.address.city_id,
                    mobile: `${this.model.phone_number.area_code} ${this.model.phone_number.number}`,
                    address_one: this.model.address1,
                    address_two: this.model.address2 //copy from address 1
                        ? this.model.address2
                        : this.model.address1,
                    postal_code: this.model.address.zip, //postal or zipcode
                    state: this.model.address.state.name,
                    company: this.model.company_name,
                })
                .then((res) => {
                    this.$store.dispatch("address", null).then((result) => {
                        if (this.$props.person == "shipper") {
                            this.$emit("sendFrom", {
                                address: res.data.data,
                                index: 0,
                            });
                        } else {
                            this.$emit("sendTo", {
                                address: res.data.data,
                                index: 0,
                            });
                        }

                        this.model.address2 = this.model.address2
                            ? this.model.address2
                            : this.model.address1;
                        this.loading = false;
                        this.$emit("cancel");
                    });
                })
                .catch((e) => {
                    this.loading = false;
                    this.model.address2 = this.model.address2
                        ? this.model.address2
                        : this.model.address1;
                    this.$refs.error.innerHTML = e.message;
                    this.$refs.error.classList.add("show");
                    this.errosList = e.data.response.data.message;
                });
        },
        edit() {
            this.loading = true;
            this.$store
                .dispatch("editAddress", {
                    id: this.addressData.id,
                    full_name: this.model.full_name,
                    email: this.model.email,
                    country_id: this.model.address.country,
                    city: this.model.address.city,
                    city_id: this.model.address.city_id,
                    mobile: `${this.model.phone_number.area_code} ${this.model.phone_number.number}`,
                    address_one: this.model.address1,
                    address_two: this.model.address2
                        ? this.model.address2
                        : this.model.address1,
                    postal_code: this.model.address.zip,
                    state: this.model.address.state.name,
                    company: this.model.company_name,
                })
                .then((res) => {
                    if (this.$props.person == "shipper") {
                        this.$emit("sendFrom", {
                            address: res.data.data,
                            index: 0,
                        });
                    } else {
                        this.$emit("sendTo", {
                            address: res.data.data,
                            index: 0,
                        });
                    }

                    this.model.address2 = this.model.address2
                        ? this.model.address2
                        : this.model.address1;
                    this.loading = false;
                    this.$emit("cancel");
                })
                .catch((e) => {
                    this.loading = false;
                    this.model.address2 = this.model.address2
                        ? this.model.address2
                        : this.model.address1;
                    this.$refs.error.innerHTML = e.message;
                    this.errosList = e.data.response.data.message;
                });
        },
        async handleCountrySelect(e) {
            // this.citiesOptions = [];
            this.model.address.city = "";
            this.model.address.state = "";
            this.model.address.zip = "";
            this.loading = true;
            this.model.address.country = e;
            this.$store.commit("citiesOptions", []);
            this.$store.commit("statesSearchResult", []);
            this.zipOptions = [];
            this.$store.dispatch("statesHandlers", e);
            this.updatePhoneNumberCode(e);

            await http(API.countries)
                .then((res) => res)
                .catch((e) => e)
                .finally(() => (this.loading = false));

            this.$store.dispatch("citiesHandlers", {
                keyword: "",
                country: this.model.address.country,
                state: "",
            });
        },
        updateCitiesFromState(e) {
            this.model.address.state = e;
            this.filterErrors("state");
        },
        districtSelected(e) {
            this.model.address.district = e;
            this.filterErrors("district");
        },
        setCitySelected(e) {
            if (e.length > 0) {
                this.$store.dispatch("citiesHandlers", {
                    keyword: e,
                    country: this.model.address.country,
                    state: this.model.address.state.id,
                });
            } else {
                this.model.address.city_id = e.city_id;
                this.model.address.city = e.name;
                this.model.address.zip = e.postalCode;

                this.currentValidCity = true;
                this.zipOptionsUpdates([e]);
                this.filterErrors("zip");
            }
            this.filterErrors("city");
        },
        handlers(keyword) {
            this.$store.dispatch("citiesHandlers", {
                keyword,
                country: this.model.address.country,
                state: this.model.address.state.id,
            });
        },
        setStateSelected(e) {
            this.model.address.state = e.name;
        },
        statesHandlers(keyword) {
            this.$store.dispatch("statesHandlers", {
                keyword,
                country: this.model.address.country,
            });
        },
        postalCodeHandlers(keyword) {
            this.model.address.zip = keyword;
            this.filterErrors("zip");

            if (!this.checkArabCountry()) {
                this.$store.commit("postCodeSearchResult", false);

                this.$store.dispatch("postalCodeHandlers", {
                    keyword,
                    country: this.model.address.country,
                    state: this.model.address.state.id,
                });
            } else {
                this.$store.commit("postCodeSearchResult", false);
            }
        },
        addValAddress() {
            this.model.address1 = this.this.model.address1;
            this.model.address2 = this.this.model.address1;
            this.filterErrors("address1");
            this.filterErrors("address2");
        },
        zipOptionsUpdates(arr) {
            let newResData = JSON.parse(JSON.stringify(arr));
            for (let obj in newResData) {
                newResData[obj].id = obj;
                newResData[obj]["name"] = newResData[obj]["postalCode"];
            }

            this.zipOptions = newResData;
            return newResData;
        },
        updatePhoneNumberCode(value) {
            for (var country of this.options) {
                if (value === country.id) {
                    this.phoneCode = country.iso;
                    this.model.phone_number.area_code = country.phone_code;
                }
            }
        },
        checkArabCountry() {
            if (
                this.model.address.country == 187 ||
                this.model.address.country == 114 ||
                this.model.address.country == 224
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    computed: {
        options() {
            return this.$store.state.countries;
        },
        code() {
            let c = this.$store.state.countries;
            let codes = [];
            c.forEach((x) => {
                codes.push({
                    id: x.id,
                    nice_name: x.phone_code.toString(),
                    iso: x.iso,
                });
            });
            return codes;
        },
        citiesOptions() {
            return this.$store.state.citiesSearchResults;
        },
        statesSearchResult() {
            return this.$store.state.statesSearchResult;
        },
        postCodeSearchResult() {
            return this.$store.state.postCodeSearchResult;
        },
        postCodeSearchResultByKeyword() {
            return this.$store.state.postCodeSearchResultByKeyword;
        },
        districtsSearchResult() {
            return this.$store.state.districtsSearchResult;
        },
    },
    mounted() {
        this.$store.dispatch("countries").then((res) => {
            this.handleCountrySelect(187);
        });
    },
    watch: {
        "model.full_name": {
            immediate: true,
            handler(val) {
                if (!val) return;
                this.model.company_name = val;
            },
        },
        statesSearchResult: {
            handler(val) {
                if (val.length) {
                    this.ignored = this.ignored.filter((k) => k != "state");
                } else {
                    this.ignored = ["countryName", "state"];
                }
            },
        },
        addressData: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                if (this.addressData) {
                    const {
                        full_name,
                        // email,
                        mobile,
                        company,
                        address_one,
                        address_two,
                        country_id,
                        country,
                        state,
                        city,
                        postal_code,
                    } = this.addressData;
                    this.model.address.zip = postal_code;

                    this.model.full_name = full_name;
                    // this.model.email = email;
                    this.model.address.country = country.id;
                    this.model.address.countryName = country;
                    this.model.address1 = address_one;
                    this.model.address2 = address_two;

                    this.model.company_name = company;
                    this.model.phone_number = {
                        number: mobile.split(" ")[1],

                        area_code: country.phone_code,
                    };
                    if (city.city_id) {
                        this.model.address.city = {
                            id: 1,
                            nice_name: city,
                            name: city,
                            postalCode: postal_code,
                        };
                    }
                    this.model.address.state = {
                        id: 1,
                        name: state,
                    };

                    this.isEditModal = true;
                    if (this.addressData.country_id == 187) {
                        this.model.address.district =
                            this.addressData.address_two.split(
                                " dist - BLDG# "
                            )[0]
                                ? this.addressData.address_two.split(
                                      " dist - BLDG# "
                                  )[0]
                                : "";
                        this.model.address.bldg =
                            this.addressData.address_two.split(
                                " dist - BLDG# "
                            )[1]
                                ? this.addressData.address_two.split(
                                      " dist - BLDG# "
                                  )[1]
                                : "";
                        this.model.address.zip =
                            this.addressData.postal_code.split("-")[0]
                                ? this.addressData.postal_code.split("-")[0]
                                : "";
                    }
                } else {
                    this.isEditModal = false;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.m-12 {
    margin-top: 12px !important;
}

.column {
    label {
        color: #777;
        font-size: 14px;
    }
    &:lang(en) {
        text-align: left !important;
    }
    &:lang(ar) {
        text-align: right !important;
    }
}

img {
    position: absolute;
    bottom: 7px;
    right: 7px;
}

.error {
    transition: 0.25s linear;
    color: #eb6174;
    visibility: hidden;
    display: inline-block;
}

.error.show {
    visibility: visible !important;
}

hr {
    display: inline-block;
    width: 75%;
    background-color: transparent;
    border: none;
    border-top: 1px solid #c2c2c2;
    margin: 0 0 25px 0;
}

.modal-custom-container {
    width: 100%;
    text-align: center;

    .main-modal {
        position: relative;
        // display: inline-block;
        background-color: #fefefe;
        border: 1px solid #f7f7f7;
        min-width: 500px;
        // min-height: 500px;
        border-radius: 15px;

        @media only screen and (max-width: 1000px) {
            min-width: 90%;

            .is-6 {
                width: 100%;
            }

            .column {
                flex-basis: auto !important;
            }
        }
    }

    .close {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }

    .button {
        line-height: 30px;
        width: 100px;
        padding: 0;
        height: 30px;
        margin: -40px 10px 0;
    }
}

.columns {
    margin-bottom: 30px;

    .column {
        position: relative;
    }
}

::v-deep {
    span {
        font-weight: 100 !important;
    }

    .select-head {
        background: #eceeff !important;
        border-bottom: none !important;

        span,
        input {
            background: #eceeff !important;
        }
    }

    .vs__dropdown-toggle {
        height: 33px;
        border: 0;
        // border-bottom: 2px solid #9b9b9b;
        color: #444444;
        font-size: 1em;
        font-weight: 400;
        transition: 0.25s ease-out;
        box-sizing: border-box;
        padding: 7px 7px 7px 16px;
        text-align: left;
        position: relative;
        text-transform: capitalize;
        border-radius: 0;
        padding: 0;
    }
}

::v-deep {
    input {
        font-weight: lighter !important;
        color: #333 !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
        line-height: 20px !important;
        font-size: 14px !important;
    }

    .search-box {
        border-bottom: none !important;
        border-radius: 5px;
        background: #eceeff;
    }

    .basic-select {
        border-bottom: none !important;
    }

    .dropdown,
    .custom-input {
        position: relative;
        display: inline-block;
        border-bottom: none !important;
        width: 100%;

        .dropdown-input,
        input {
            width: 100%;
            border-radius: 5px;
            background: #eceeff;
            padding: 5px 10px;
            color: #444444;
            font-size: 1em;
            font-weight: 100 !important;
            -webkit-transition: 0.25s ease-out;
            transition: 0.25s ease-out;
            display: inline-block;
            border: none !important;
        }
    }

    .dropdown {
        margin: 4px !important;

        input:focus {
            outline: none;
        }
    }

    .dropdown-input {
        font-size: 15px;
    }

    .phone-code {
        .basic-select {
            height: 40px;

            ul {
                height: 160px;
            }
        }
    }

    .phone-code-helper {
        padding: 0;
        margin: auto 0;
    }
}
</style>
